import * as _ from 'lodash';

import { Config } from '../config/env.config';


export const setItemDetailValidation = (itemDetail: any, scorecardId?: string | undefined): any => {

  itemDetail.validation = _.pick(itemDetail.validation, [
    ...Config.VALIDATION_TYPES, 'has_invalid_fitment'
  ]);
  const combinedErrors: any = [];
  const segmentErrors: any = [];
  if (typeof scorecardId === 'undefined') {
    _.each(itemDetail.validation, (validation) => {
      _.each(validation, (error: any) => {
        segmentErrors.push(error.segment);
        combinedErrors.push(error.segment + '.' + error.path);
      });
    });
  } else {
    const validationRule: string = scorecardId.replace('-', '');
    const segmentValidation = _.get(itemDetail.validation, validationRule);
    _.each(segmentValidation, (error: any) => {
      segmentErrors.push(error.segment);
      combinedErrors.push(error.segment + '.' + error.path);
    });
  }

  if (!_.has(itemDetail, 'validation')) {
    itemDetail.validation = {};
  }
  // extended information fields are inside packages segment
  if (_.includes(segmentErrors, 'extendedInformation')) {
    segmentErrors.push('packages');
  }
  if (_.get(itemDetail, 'validation.has_invalid_fitment')) {
    segmentErrors.push('fitments');
    combinedErrors.push('fitments');
  }
  itemDetail.validation.combinedErrors = _.uniq(combinedErrors);
  itemDetail.validation.segmentErrors = _.uniq(segmentErrors);
  return itemDetail;
};
